import { useContext, useEffect, useRef, useState } from 'react';
import { UserContext } from '../../components/shared/useUser';
import useNswagClient from '../api/useNswagClient';
import { ConfigurationName } from '../../enums/ConfigurationName';

const useStockCountAutoApprovalConfiguration = (): boolean => {
  const { selectedStore } = useContext(UserContext);
  const { getConfiguration } = useNswagClient();
  const [isAutoApprovalEnabled, setIsAutoApprovalEnabled] = useState(false);
  const getConfigurationRef = useRef(getConfiguration);
  getConfigurationRef.current = getConfiguration;

  useEffect(() => {
    let isCancelled = false;

    const fetchAutoApproval = async () => {
      if (!selectedStore?.storeNumber || !selectedStore?.franchiseName) {
        if (!isCancelled) setIsAutoApprovalEnabled(false);
        return;
      }

      setIsAutoApprovalEnabled(false);

      try {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const response: any = await getConfigurationRef.current(
          ConfigurationName.StockCountAutoApprovalPerCount,
          selectedStore.storeNumber,
          selectedStore.franchiseName,
        );
        const value = response?.data?.value;
        if (!isCancelled) {
          setIsAutoApprovalEnabled(value === true || value === 'true' || value === '1');
        }
      } catch {
        if (!isCancelled) setIsAutoApprovalEnabled(false);
      }
    };

    fetchAutoApproval();

    return () => {
      isCancelled = true;
    };
  }, [selectedStore?.franchiseName, selectedStore?.storeNumber]);

  return isAutoApprovalEnabled;
};

export default useStockCountAutoApprovalConfiguration;
